
type aliveScopeType = ({
    drop: (args?: any) => void,
    dropScope:  (args?: any) => void,
    clear:  (args?: any) => void,
    getCachingNodes: any
}) | null | undefined
class GlobalConfig {
    private static instanceOfGlobal: GlobalConfig | null;
    private history: any = null;
    private aliveScope: aliveScopeType = null;
    private report: any = null;
    constructor(history?: History, aliveScope?: aliveScopeType, report?: History) {
        if (GlobalConfig.instanceOfGlobal) {
            return GlobalConfig.instanceOfGlobal
        }
        this.history = history;
        this.aliveScope = aliveScope;
        this.report = report;
        GlobalConfig.instanceOfGlobal = this;
    }
    getHistory() {
        return this.history || {}
    }
    setHistory(history: History) {
        this.history = history;
    }
    getAliveScope() {
        return this.aliveScope
    }
    setAliveScope(aliveScope: aliveScopeType) {
        this.aliveScope = aliveScope
    }
    getReport() {
        return this.report;
    };
    setReport(aggregate: History) {
        this.report = aggregate;
    };
    clear() {
        this.aliveScope?.clear()
        this.aliveScope = null
        this.history = null
        this.report = null
        GlobalConfig.instanceOfGlobal = null
    }
}
export default GlobalConfig